<template>
    <div
        v-html="data"
        class="products-detail-content html-content"
        ref="container"
    ></div>
</template>

<script>
/* eslint-disable no-undef */
export default {
    name: 'products-detail-content',
    data () {
        return {
            tabs: undefined,
            tabsInfo: {}
        }
    },
    props: {
        data: {
            type: String,
            default: ''
        }
    },
    mounted () {
        this.tabs = $('.js-tabs')
        this.initSpoiler()
        this.checkHash({scroll: true})
        window.addEventListener('hashchange', () => { this.checkHash({scroll: true}) })
    },
    methods: {
        initSpoiler () {
            const container = this.$refs.container
            if (!container) return

            const spoiler = container.querySelectorAll('.spoiler')
            spoiler.forEach(item => {
                const button = item.querySelector('.spoiler__button')

                button.addEventListener('click', e => {
                    e.preventDefault()
                    item.classList.add('is-expand')
                })
            })
        },
        getHash () {
            this.tabsInfo.hash = window.location.hash.split('!')
            this.tabsInfo.href = this.tabsInfo.hash[0]
            this.tabsInfo.ePath = this.tabsInfo.hash[1]
            this.tabsInfo.name = this.tabsInfo.href.substr(1)
            this.tabsInfo.type = undefined

            if (this.tabs.find(`.tabs__button[href="${this.tabsInfo.href}"]`).length) {
                this.tabsInfo.type = 'tabs'
            }
        },
        checkHash (options) {
            this.getHash()

            if (this.tabsInfo.hash[0].length > 1) {
                this.openParents(this.tabsInfo)

                if (this.tabsInfo.type === 'tabs') {
                    this.openTabs(this.tabsInfo, options.scroll)
                }
            } else {
                this.tabsInit()
            }
        },
        openParents () {
            let $parents = $(`[href="${this.tabsInfo.href}"]`).parents('.tabs__article, .accordion__section')
            $parents.each(function (index) {
                let $this = $(this)
                if ($this.hasClass('tabs__article')) {
                    let name = $this.attr('data-article')
                    this.openTabs({ href: `#${name}`, name: name })
                }
            })
        },
        openTabs (data, scroll) {
            let $thisTabs = this.tabs.find(`a[href="${data.href}"]`).closest('.tabs')
            $thisTabs
                .find('.tabs__header')
                .find('.tabs__button')
                .removeClass('is-expand')
                .closest(`a[href="${data.href}"]`)
                .addClass('is-expand')
                .closest('.tabs')
                .find('.tabs__article')
                .removeClass('is-expand')
                .closest(`[data-article="${data.name}"]`)
                .addClass('is-expand')

            if (scroll) {
                this.scrollToElement(data.href)
            }

            $(window).trigger('resize')
        },
        scrollToElement (href) {
            let topPos = $(`[href="${href}"]`).offset().top

            $('html')
                .velocity('stop')
                .velocity('scroll', {
                    offset: `${topPos}px`,
                    duration: 500,
                    mobileHA: false
                })
        },
        tabsInit () {
            this.tabs.each(function (index, el) {
                let $this = $(el)
                let $showTab = $this.attr('data-show-tab')
                let $href = ($showTab !== undefined && $tabs.find(`.tabs__button[href="#${$showTab}"]`).length) ? (`#${$showTab}`) : $this.find('.tabs__button').eq(0).attr('href')
                let $name = $href.substr(1)
                window.location.hash = $name
            })
        }
    }
}
</script>

<style lang="scss">
.products-detail-content {
    h4 {
        color: inherit !important;
        margin-top: $token-spacers-s;
    }

    .spoiler {

        &__inner {
            max-height: 640px;
            overflow: hidden;
            margin-bottom: $token-spacers-l;
            position: relative;

            &:after {
                content: '';
                display: block;
                width: 100%;
                height: 64px;
                position: absolute;
                left: 0;
                bottom: 0;
                background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 70%, rgba(255, 255, 255, 1) 100%);
                background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 70%, rgba(255, 255, 255, 1) 100%);
                background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 70%, rgba(255, 255, 255, 1) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);
            }
        }

        &__button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: none;
            outline: 0;
            text-align: center;
            text-decoration: none;
            cursor: pointer;
            transition: all $transition;
            font-size: 16px;
            font-weight: 500;
            line-height: 1.2;
            color: $token-colors-white;
            background-color: $token-colors-button-primary-bg-default;
            padding: 10px $token-spacers-s;
            margin-bottom: 24px;

            .z-icon {
                path {
                    fill: $token-colors-white;
                }
            }

            &:hover {
                background-color: $token-colors-button-primary-bg-hover;
                box-shadow: 0px 16px 16px -6px rgba($token-colors-button-primary-bg-hover, 0.35);
            }

            &:active,
            &:focus {
                background-color: $token-colors-button-primary-bg-active;
                box-shadow: 0px 16px 16px -6px rgba($token-colors-button-primary-bg-active, 0.35);
            }

            &[disabled] {
                background-color: $token-colors-button-primary-bg-disabled;
            }
        }

        &.is-expand {

            .spoiler__inner {
                max-height: none;
                margin: 0;

                &:after {
                    display: none;
                }
            }

            .spoiler__button {
                display: none;
            }
        }
    }

    .tabs {
        $parent: &;

        // basic styles

        *:focus {
            outline: none;
        }

        *::-moz-focus-inner {
            border: 0;
        }

        &__container {
            overflow: hidden;
            overflow-x: auto;
            display: flex;
            padding-bottom: 4px;
            z-index: 1;
        }

        &__header {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex: 1 1 100%;
            flex-flow: row nowrap;
            border-bottom: 1px solid #E5E5E5;

            &--flex-end {
                align-items: flex-end;
            }
        }

        &__button {
             display: block;
            position: relative;
            height: 100%;
            font-size: 22px;
            font-weight: 500;
            line-height: 1.3;
            color: $token-colors-black-40;
            text-decoration: none;
            transition: color .3s, opacity .3s;
            padding-bottom: $token-spacers-m;
            margin: 0 $token-spacers-s;

            @include breakpoint(tablet) {
                white-space: nowrap;
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }

            &:after {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                bottom: -1px;
                display: block;
                width: 0;
                height: 8px;
                transition: width .4s;
                margin: auto;
            }

            &:hover:not(.z-tabs-label--opened) {
                color: #EE7918;
            }

            &.is-expand {
                color: $token-colors-black;

                &:after {
                    width: 100%;
                    background-color: #E42213;
                }
            }

            &--right {
                margin-left: auto;
            }
        }

        &__article {
            display: none;
            padding: 1.5rem 0;

            &.is-expand {
                display: block;
            }
        }
    }

    @include breakpoint(tablet) {
        .tabs--products {
            .tabs__button>span {
                display: none;
            }
        }
    }

    @include breakpoint(mobile) {
        .tabs__button {
            white-space: nowrap;
        }
    }

    .tabs {
        $parent: &;

        // basic styles

        *:focus {
            outline: none;
        }

        *::-moz-focus-inner {
            border: 0;
        }

        &__container {
            overflow: hidden;
            overflow-x: auto;
            display: flex;
            padding-bottom: 4px;
            z-index: 1;
        }

        &__header {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex: 1 1 100%;
            flex-flow: row nowrap;
            border-bottom: 1px solid #E5E5E5;

            &--flex-end {
                align-items: flex-end;
            }
        }

        &__button {
            display: block;
            position: relative;
            height: 100%;
            font-size: 22px;
            font-weight: 500;
            line-height: 1.3;
            color: $token-colors-black-40;
            text-decoration: none;
            transition: color .3s, opacity .3s;
            padding-bottom: $token-spacers-m;
            margin: 0 $token-spacers-s;

            @include breakpoint(tablet) {
                white-space: nowrap;
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }

            &:after {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                bottom: -1px;
                display: block;
                width: 0;
                height: 8px;
                transition: width .4s;
                margin: auto;
            }

            &:hover:not(.z-tabs-label--opened) {
                color: #EE7918;
            }

            &.is-expand {
                color: $token-colors-black;

                &:after {
                    width: 100%;
                    background-color: #E42213;
                }
            }

            &--right {
                margin-left: auto;
            }
        }

        &__article {
            display: none;
            padding: 1.5rem 0;

            &.is-expand {
                display: block;
            }
        }
    }

    @include breakpoint(tablet) {
        .tabs--products {
            .tabs__button>span {
                display: none;
            }
        }
    }

    @include breakpoint(mobile) {
        .tabs__button {
            white-space: nowrap;
        }
    }
}
</style>
